import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { CvaLoaderProps } from '../types';

export const CvaLoader = ({ classname, width }: CvaLoaderProps) => {
  return (
    <div className={classname}>
      <CatSkeleton size="sm" width={width} />
    </div>
  );
};

export default CvaLoader;
